module.exports = __webpack_public_path__ + "img/trc_button.c1046402.png";